const settingsReducer = (state = {}, action) => {
    switch (action.type) {
        case "SETTING_SSO_LOADED_SUCCESS":
            return Object.assign({}, state, {
                getSsoDetails: action.data,
            });
        case "CREATE_SSO_LOADED_SUCCESS":
            return Object.assign({}, state, {
                createIdentityProviders: action.data,
            });
        case "UPDATE_SSO_LOADED_SUCCESS":
            return Object.assign({}, state, {
                updateIdentityProviders: action.data,
            });
        case "DELETE_SSO_LOADED_SUCCESS":
            return Object.assign({}, state, {
                deleteIdentityProviders: action.data,
            });
        case "LOGOUT_ALLUSERS":
            return Object.assign({}, state, {
                LogoutAllUsers: action.data,
            });
        default:
            return state;
    }
};

export default settingsReducer;